module.exports = __webpack_public_path__ + "img/1.d6269ab4.jpeg";